<template>
	<div>
		<span class="spanlabel">{{OrderName}}</span>
		<span class="spanlabel">总已约：{{bookednum}}人；待约：{{nobooknum}}人</span>
		<div>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="图表明细" name="tab1">
					<OrderBookChart v-if="showtab1" :inorder="orderent"></OrderBookChart>
				</el-tab-pane>

				<el-tab-pane label="数据明细" name="tab2">
					<OrderBookData v-if="showtab2" :inordercuss="OrderCusList"></OrderBookData>
				</el-tab-pane>
			</el-tabs>

		</div>
	</div>
</template>

<script>
	import order from '../../apifunction/Order.js'
	import ordercus from '../../apifunction/OrderCus.js'
	import OrderBookChart from './OrderBookChart.vue'
	import OrderBookData from './OrderBookData.vue'
	export default {
		created() {
			var ent = this.$route.query.ent;
			this.orderent = JSON.parse(ent);
			this.InitData();
		},
		components: {
			OrderBookChart,
			OrderBookData
		},
		data() {
			return {
				orderent: null,
				OrderName: "",
				OrderCusList: [],
				bookednum: 0,
				nobooknum: 0,
				activeName: 'tab1',
				showtab1: true,
				showtab2: false
			}
		},
		methods: {
			InitData() {
				this.OrderName = this.orderent.OrderName;
				ordercus.GetOrderCusByOrder(this.orderent.OrderID)
					.then(res1 => {
						let ent1 = JSON.parse(JSON.stringify(res1.data))
						if (ent1.Flag == 'success') {
							this.OrderCusList = JSON.parse(ent1.Data)
							if (this.OrderCusList.length > 0) {
								this.bookednum = 0;
								this.nobooknum = 0;
								for (let i = 0; i < this.OrderCusList.length; i++) {
									if (this.OrderCusList[i].cusstatus < 30 || this.OrderCusList[i].cusstatus == '40')
										this.nobooknum++;
									else
										this.bookednum++;
								}
							}
						} else
							this.$message.info(ent.Msg);
					});

			},
			handleClick() {
				if (this.activeName == "tab1") {
					this.showtab1 = true;
					this.showtab2 = false;
				} else {
					this.showtab1 = false;
					this.showtab2 = true;
				}
			}
		}
	}
</script>

<style>
</style>
